import React from 'react';
import ExpenseForm from '../components/expenses/ExpenseForm';
import ExpenseTable from '../components/expenses/ExpenseTable';

export default function ExpensesPage() {
    return (
        <div>
            <h1 className="h3 mb-4">Despesas</h1>
            <div className="row">
                <div className="col-lg-4 mb-4">
                    <ExpenseForm />
                </div>
                <div className="col-lg-8">
                    <ExpenseTable />
                </div>
            </div>
        </div>
    );
}
